/* Parman side cart.
   Renders from /cart.js, opens on add-to-cart and on the header cart icon.
   Every form still posts to /cart/add without JS, landing on the cart page. */
(function () {
  'use strict';

  var root = document.querySelector('[data-pm-drawer]');
  if (!root) return;

  var itemsHost = root.querySelector('[data-pm-drawer-items]');
  var emptyEl = root.querySelector('[data-pm-drawer-empty]');
  var offersEl = root.querySelector('[data-pm-drawer-offers]');
  var footEl = root.querySelector('[data-pm-drawer-foot]');
  var countEl = root.querySelector('[data-pm-drawer-count]');
  var totalEl = root.querySelector('[data-pm-drawer-total]');
  var tpl = document.querySelector('[data-pm-drawer-item-tpl]');
  var utpl = document.querySelector('[data-pm-drawer-upsell-tpl]');
  var shipbar = root.querySelector('[data-pm-shipbar]');
  var shipText = root.querySelector('[data-pm-shipbar-text]');
  var shipFill = root.querySelector('[data-pm-shipbar-fill]');
  var upsellWrap = root.querySelector('[data-pm-drawer-upsell]');
  var upsellRail = root.querySelector('[data-pm-drawer-upsell-rail]');
  var upsellFor = null;
  var upsellDots = root.querySelector('[data-pm-drawer-upsell-dots]');
  var upsellIdx = 0;
  var upsellTimer = null;
  var upsellHeld = false;

  /* One card in view; step through the stack every few seconds. Dots mark
     the active card and jump on tap. Any touch pauses the walk for a beat;
     reduced motion never auto-advances. */
  var upsellCards = function () {
    return upsellRail ? upsellRail.querySelectorAll('.pm-drawer__ucard') : [];
  };
  var markDots = function () {
    if (!upsellDots) return;
    upsellDots.querySelectorAll('button').forEach(function (b, j) {
      b.classList.toggle('is-on', j === upsellIdx);
    });
  };
  var goUpsell = function (i) {
    var cards = upsellCards();
    if (!cards.length) return;
    upsellIdx = (i + cards.length) % cards.length;
    upsellRail.scrollTo({
      top: cards[upsellIdx].offsetTop - cards[0].offsetTop,
      behavior: 'smooth',
    });
    markDots();
  };
  var holdUpsell = function () {
    upsellHeld = true;
    setTimeout(function () { upsellHeld = false; }, 6000);
  };
  var setupUpsellPlay = function () {
    if (upsellTimer) { clearInterval(upsellTimer); upsellTimer = null; }
    if (!upsellDots || !upsellRail) return;
    var cards = upsellCards();
    upsellDots.innerHTML = '';
    upsellDots.hidden = cards.length < 2;
    upsellIdx = 0;
    if (cards.length < 2) return;
    cards.forEach(function (c, j) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Suggestion ' + (j + 1) + ' of ' + cards.length);
      b.addEventListener('click', function () { holdUpsell(); goUpsell(j); });
      upsellDots.appendChild(b);
    });
    markDots();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    upsellTimer = setInterval(function () {
      if (upsellHeld || root.hidden) return;
      goUpsell(upsellIdx + 1);
    }, 3200);
  };
  var closeBtn = root.querySelector('.pm-drawer__close');
  var lastFocus = null;
  var busy = false;

  var money = function (paise) {
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  };

  var setCount = function (n) {
    document.querySelectorAll('.pm-header__count').forEach(function (b) {
      b.textContent = n;
      b.style.display = n > 0 ? '' : 'none';
    });
    // the icon may not carry a bubble yet when the cart started empty
    if (n > 0 && !document.querySelector('.pm-header__count')) {
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) {
        var b = document.createElement('span');
        b.className = 'pm-header__count';
        b.textContent = n;
        icon.appendChild(b);
      }
    }
  };

  var render = function (cart) {
    itemsHost.innerHTML = '';
    var has = cart.items && cart.items.length > 0;

    emptyEl.hidden = has;
    footEl.hidden = !has;
    var trustBand = root.querySelector('[data-pm-drawer-trust]');
    if (trustBand) trustBand.hidden = !has;
    if (offersEl) offersEl.hidden = !has;
    countEl.hidden = !has;
    if (has) countEl.textContent = 'Items (' + cart.item_count + ')';
    if (totalEl) totalEl.textContent = money(cart.total_price);
    var savedEl = root.querySelector('[data-pm-drawer-saved]');
    if (savedEl) {
      var saved = cart.total_discount || 0;
      savedEl.hidden = !(has && saved > 0);
      if (saved > 0) {
        // 2 Nov: name the discount that applied, as the Liquid render does
        var discTitle = '';
        Array.prototype.concat.apply((cart.cart_level_discount_applications || []).slice(), (cart.items || []).map(function (it) {
          return (it.line_level_discount_allocations || []).map(function (a) { return a.discount_application || {}; });
        })).some(function (a) { return (discTitle = a.title || '') !== ''; });
        savedEl.textContent = (discTitle ? discTitle + ' applied. ' : '') + 'You saved ' + money(saved);
      }
    }
    setCount(cart.item_count);

    /* Shipping bar. Threshold 0 = shipping is free on every order, so the
       bar is always full and states the true claim. A real threshold makes
       it progressive: remaining amount, then the earned state. */
    if (shipbar) {
      shipbar.hidden = !has;
      if (has) {
        var threshold = parseInt(shipbar.dataset.threshold || '0', 10) * 100;
        if (threshold > 0 && cart.total_price < threshold) {
          shipText.innerHTML = (shipbar.dataset.more || 'Add <b>[amount]</b> more for free shipping').split('[amount]').join(money(threshold - cart.total_price));
          shipFill.style.width = Math.min(99, Math.round(cart.total_price * 100 / threshold)) + '%';
          shipbar.classList.remove('is-earned');
        } else {
          shipText.innerHTML = shipbar.dataset.earned || 'You have <b>free shipping</b> across India';
          shipFill.style.width = '100%';
          shipbar.classList.add('is-earned');
        }
      }
    }

    if (!has) {
      if (upsellWrap) upsellWrap.hidden = true;
      if (upsellTimer) { clearInterval(upsellTimer); upsellTimer = null; }
      return;
    }
    upsell(cart);
    cart.items.forEach(function (item, i) {
      var node = tpl.content.cloneNode(true);
      var t = function (k) { return node.querySelector('[data-t="' + k + '"]'); };
      node.querySelectorAll('[data-t="url"]').forEach(function (a) { a.href = item.url; });
      var img = t('img');
      if (item.image) {
        img.src = item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2');
        img.alt = item.title;
      } else {
        img.remove();
      }
      t('title').textContent = item.product_title;
      var v = t('variant');
      if (item.variant_title && item.variant_title !== 'Default Title') {
        v.textContent = item.variant_title;
      } else {
        v.remove();
      }
      t('price').textContent = money(item.final_line_price);
      t('qty').textContent = item.quantity;
      t('minus').addEventListener('click', function () { change(i + 1, item.quantity - 1); });
      t('plus').addEventListener('click', function () { change(i + 1, item.quantity + 1); });
      t('remove').addEventListener('click', function () { change(i + 1, 0); });
      itemsHost.appendChild(node);
    });
  };

  var refresh = function () {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  };

  var change = function (line, qty) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {})
      .then(function () {
        busy = false;
        root.classList.remove('is-busy');
      });
  };

  var open = function () {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    // The server-rendered state is already on screen; the refresh only
    // replaces it when /cart.js actually succeeds.
    refresh().then(function () { if (closeBtn) closeBtn.focus(); });
  };

  /* Server-rendered controls from the Liquid first paint */
  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-ssr-qty]');
    if (q) {
      var parts = q.dataset.ssrQty.split(':');
      change(parseInt(parts[0], 10), parseInt(parts[1], 10));
      return;
    }
    var r = e.target.closest('[data-ssr-remove]');
    if (r) { change(parseInt(r.dataset.ssrRemove, 10), 0); return; }
    var a = e.target.closest('[data-ssr-add]');
    if (a && !busy) {
      busy = true; a.classList.add('is-adding');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(a.dataset.ssrAdd, 10), quantity: 1 }),
      })
        .then(function (x) { return x.json(); })
        .then(function () { busy = false; a.classList.remove('is-adding'); upsellFor = null; refresh(); })
        .catch(function () { busy = false; a.classList.remove('is-adding'); });
    }
  });

  var close = function () {
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 260);
    if (lastFocus) lastFocus.focus();
  };

  root.querySelectorAll('[data-pm-drawer-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  /* Header cart icon opens the drawer; the href stays as the fallback. */
  var icon = document.getElementById('cart-icon-bubble');
  if (icon && !/\/cart\/?$/.test(location.pathname)) {
    icon.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  }

  /* Any add-to-cart form on the page adds via AJAX and opens the drawer:
     the PDP buy box, the sticky bar, card quick-adds and stack quick-adds.
     Buy now (name=checkout) keeps its native submit straight to checkout. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"], .pm-cell__addform, .pm-stack__addform, #PmProductForm')) return;
    // pendant + chosen chain go in as two lines (29 Oct); Buy now then goes on to checkout
    var chainEl = form.querySelector('[data-pm-chain-id]');
    var chainId = chainEl && chainEl.value;
    var toCheckout = e.submitter && e.submitter.name === 'checkout';
    if (toCheckout && !chainId) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    var submitBtn = form.querySelector('[type="submit"], button:not([type])') || e.submitter;
    if (submitBtn) submitBtn.classList.add('is-adding');
    var body = new FormData(form);
    if (chainId) {
      var multi = new FormData();
      body.forEach(function (v, k) {
        if (k === 'id' || k === 'quantity' || k === 'selling_plan') multi.append('items[0][' + k + ']', v);
        else if (k.indexOf('properties[') === 0) multi.append('items[0][properties]' + k.slice(10), v);
      });
      if (!multi.has('items[0][quantity]')) multi.append('items[0][quantity]', '1');
      multi.append('items[1][id]', chainId);
      multi.append('items[1][quantity]', '1');
      var forEl = form.querySelector('[data-pm-chain-for]');
      if (forEl) multi.append('items[1][properties][With pendant]', forEl.value);
      body = multi;
    }
    fetch('/cart/add.js', { method: 'POST', body: body })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        busy = false;
        if (submitBtn) submitBtn.classList.remove('is-adding');
        if (toCheckout && res && res.items) { window.location.href = '/checkout'; return; }
        if (res && (res.id || res.items)) open();
        else if (res && res.description) alert(res.description);
      })
      .catch(function () {
        busy = false;
        if (submitBtn) submitBtn.classList.remove('is-adding');
        form.submit();
      });
  });

  /* Upsell rail: Shopify's native recommendations for the first cart item.
     Single variant products add in place; multi variant products link to the
     product page so a colour or size is chosen, never assumed. */
  var upsell = function (cart) {
    if (!upsellWrap || !utpl || !cart.items.length) return;
    var lead = cart.items[0].product_id;
    if (upsellFor === lead) return;   // already rendered for this lead item
    upsellFor = lead;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    fetch('/recommendations/products.json?product_id=' + lead + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || []).filter(function (pr) {
          return inCart.indexOf(pr.id) === -1 && pr.available !== false;
        }).slice(0, 6);
        upsellRail.innerHTML = '';
        if (!prods.length) { upsellWrap.hidden = true; return; }
        prods.forEach(function (pr) {
          var node = utpl.content.cloneNode(true);
          var t = function (k) { return node.querySelector('[data-t="' + k + '"]'); };
          node.querySelectorAll('[data-t="url"]').forEach(function (a) { a.href = pr.url; });
          var img = t('img');
          if (pr.featured_image) { img.src = pr.featured_image; img.alt = pr.title; }
          else img.remove();
          t('title').textContent = pr.title;
          t('price').textContent = money(pr.price);
          var add = t('add');
          var vars = pr.variants || [];
          if (vars.length === 1 && vars[0].available !== false) {
            add.addEventListener('click', function () {
              if (busy) return;
              busy = true; add.classList.add('is-adding');
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: vars[0].id, quantity: 1 }),
              })
                .then(function (r) { return r.json(); })
                .then(function () { busy = false; add.classList.remove('is-adding'); upsellFor = null; refresh(); })
                .catch(function () { busy = false; add.classList.remove('is-adding'); });
            });
          } else {
            // options exist: choose on the product page, never assume one
            var a = document.createElement('a');
            a.href = pr.url;
            a.setAttribute('aria-label', 'Choose options');
            a.className = 'pm-drawer__ucard-add pm-drawer__ucard-add--link';
            a.innerHTML = '&rsaquo;';
            add.replaceWith(a);
          }
          upsellRail.appendChild(node);
        });
        upsellWrap.hidden = false;
        setupUpsellPlay();
      })
      .catch(function () { upsellWrap.hidden = true; });
  };

  if (upsellRail) {
    upsellRail.addEventListener('pointerdown', holdUpsell);
    upsellRail.addEventListener('touchstart', holdUpsell, { passive: true });
    upsellRail.addEventListener('scroll', function () {
      var cards = upsellCards();
      if (cards.length < 2) return;
      var step = cards[1].offsetTop - cards[0].offsetTop;
      if (step <= 0) return;
      var i = Math.max(0, Math.min(cards.length - 1, Math.round(upsellRail.scrollTop / step)));
      if (i !== upsellIdx) { upsellIdx = i; markDots(); }
    }, { passive: true });
    // the server-rendered stack is on screen before any fetch runs
    setupUpsellPlay();
  }

  /* "+N more offers, view all coupons": reveal the rest of the list */
  var moreBtn = root.querySelector('[data-pm-offers-more]');
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      root.querySelectorAll('.pm-drawer__offerlist li[hidden]').forEach(function (li) { li.hidden = false; });
      moreBtn.hidden = true;
    });
  }

  /* Tap-to-copy coupon rows */
  root.querySelectorAll('[data-pm-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var code = b.dataset.pmCopy;
      var done = function () {
        b.classList.add('is-copied');
        var c = b.querySelector('.pm-drawer__offer-code');
        if (c) {
          var orig = c.textContent;
          c.textContent = 'Copied';
          setTimeout(function () {
            c.textContent = orig;
            b.classList.remove('is-copied');
          }, 1400);
        }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        done();
      }
    });
  });
})();
